<div class="footer">
    réalisé par scfi - {{ year }}
</div>